var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"primary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }